<template>
  <div class="container-fluid login-wrap">
    <div class="row justify-content-center">
      <div class="col-md-12 mx-4">
        <div class="login-logo-wrap">
          <img src="/img/svg/expense_guide_logo_login.svg" alt="expense.guide logo" class="logo-login">
        </div>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>

        <div class="row form-wrap">
          <div class="col-lg-12">

            <div class="form-group-row login-up">
              <input id="email" v-model="form.email" :class="{ 'is-invalid': errors.email }" type="email" class="form-control login-username" required="required" placeholder="E-mail address" autofocus >
              <span v-if="errors.email" class="invalid-feedback">
                <div v-for="(error, index) in errors.email" :key="index"><strong>{{ error }}</strong></div>
              </span>
              <span class="clearfix"/>
            </div>

            <div class="form-group-row login-up">
              <input id="password" v-model="form.password" :class="{ 'is-invalid': errors.password }" type="password" class="form-control login-password" required="required" placeholder="Password" @keyup.enter="submit()">
              <span v-if="errors.password" class="invalid-feedback">
                <div v-for="(error, index) in errors.password" :key="index"><strong>{{ error }}</strong></div>
              </span>
              <span class="clearfix"/>
            </div>

            <div class="form-group-row center">
              <button type="submit" class="btn btn-primary" @click.prevent="submit()">
                <span v-if="this.$loading.isLoading('logging-in')" class="btn-inline-text login"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span>
                <span class="btn-inline-text login">Login</span>
              </button>
              <div><a class="btn btn-link login-forgot-password" href="#/reset-password-request">Forgot Password?</a></div>
              <div style="margin-bottom: 10px;"><a class="btn btn-link login-registration" href="#/registration">Registration</a></div>
              <div><a class="btn btn-link login-forgot-password" href="#/terms-of-service">Terms and conditions</a></div>
              <div><a class="btn btn-link login-registration" href="#/privacy-policy">Privacy policy</a></div>
            </div>

          </div>
        </div>
        <div class="row login-motto-wrap">
          <div class="col-lg-12">
            <div class="login-motto">
              It's more about planning the future,<br > than thinking about the past.
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      error: '',
      errors: {}
    }
  },
  methods: {
    ...mapActions([
      'login'
    ]),
    submit () {
      this.$loading.startLoading('logging-in')
      this.errors = {}
      this.login(this.form)
        .then(() => {
          this.$loading.endLoading('logging-in')
          this.$router.replace('/dashboard')
        })
        .catch((data) => {
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('logging-in')
        })
    }
  }
}
</script>
